export default "__VITE_ASSET__2de434e7__"